import { lazy } from "react";

// Dashboard - Original component
import DashboardPage from "../pages/dashboard/index.jsx";
export { DashboardPage };

// Bookkeeping/Pembukuan
export const StartingBalance = lazy(() => import("../pages/bookkeping/startingBalance"));
export const Migration = lazy(() => import("../pages/bookkeping/migration"));
export const ViewMigration = lazy(() => import("../pages/bookkeping/migration/view"));
export const UploadMigration = lazy(() => import("../pages/bookkeping/migration/upload"));
export const EditMigration = lazy(() => import("../pages/bookkeping/migration/edit"));
export const Ledger = lazy(() => import("../pages/bookkeping/ledger"));
export const ViewLedger = lazy(() => import("../pages/bookkeping/ledger/view"));
export const AddLedger = lazy(() => import("../pages/bookkeping/ledger/create"));
export const EditLedger = lazy(() => import("../pages/bookkeping/ledger/edit"));
export const LedgerCG = lazy(() => import("../pages/bookkeping/ledgerCG"));
export const LedgerCGForm = lazy(() => import("../pages/bookkeping/ledgerCG/form"));
export const Expense = lazy(() => import("../pages/bookkeping/expense"));
export const ViewExpense = lazy(() => import("../pages/bookkeping/expense/view"));
export const AddExpense = lazy(() => import("../pages/bookkeping/expense/create"));
export const EditExpense = lazy(() => import("../pages/bookkeping/expense/edit"));
export const Revenue = lazy(() => import("../pages/bookkeping/revenue"));
export const ViewRevenue = lazy(() => import("../pages/bookkeping/revenue/view"));
export const AddRevenue = lazy(() => import("../pages/bookkeping/revenue/create"));
export const EditRevenue = lazy(() => import("../pages/bookkeping/revenue/edit"));
export const ClosingCycle = lazy(() => import("../pages/bookkeping/closingCycle"));

// Master Data
export const Activities = lazy(() => import("../pages/master/activities"));
export const ActivityCategories = lazy(() => import("../pages/master/activityCategories"));
export const BudgetPosts = lazy(() => import("../pages/master/budgetposts"));
export const CoaCategory = lazy(() => import("../pages/master/coacategory"));
export const CoaPage = lazy(() => import("../pages/master/coa"));
export const CreateCoaPage = lazy(() => import("../pages/master/coa/create"));
export const EditCoaPage = lazy(() => import("../pages/master/coa/edit"));
export const DownloadCoaPage = lazy(() => import("../pages/master/coa/download"));
export const UploadCoaPage = lazy(() => import("../pages/master/coa/upload"));
export const WorkflowsPage = lazy(() => import("../pages/master/workflow"));
export const EditWorkflow = lazy(() => import("../pages/master/workflow/edit"));

// Settings/Pengaturan
export const SettingJournalNumber = lazy(() => import("../pages/settings/journalNumber"));
export const SettinigProfitLoss = lazy(() => import("../pages/settings/profitLoss"));
export const SettingNetProfitLoss = lazy(() => import("../pages/settings/netProfitLoss"));
export const SettingBalanceSheet = lazy(() => import("../pages/settings/balanceSheet"));
export const SettingCashFlow = lazy(() => import("../pages/settings/cashFlow"));
export const SettingFilterAccount = lazy(() => import("../pages/settings/filterAccount"));
export const SettingRoles = lazy(() => import("../pages/settings/roles"));
export const SettingCreateRole = lazy(() => import("../pages/settings/roles/create"));
export const SettingUpdateRole = lazy(() => import("../pages/settings/roles/edit"));
export const SettingUser = lazy(() => import("../pages/settings/user"));
export const SettingCreateUser = lazy(() => import("../pages/settings/user/create"));
export const SettingUpdateUser = lazy(() => import("../pages/settings/user/edit"));
export const SettingBudgeting = lazy(() => import("../pages/settings/budgeting"));
export const SettingBudgetNumber = lazy(() => import("../pages/settings/budgetNumber"));

// Reports/Laporan
export const ReportLedger = lazy(() => import("../pages/report/ledger"));
export const ReportProfitLoss = lazy(() => import("../pages/report/profitLoss"));
export const ReportBalanceSheet = lazy(() => import("../pages/report/balanceSheet"));
export const ReportCashFlow = lazy(() => import("../pages/settings/cashFlow"));

// Budgeting/Anggaran
export const BudgetActivity = lazy(() => import("../pages/budgeting/activity"));
export const FundRequests = lazy(() => import("../pages/budgeting/fundRequests"));
export const AddBudgetActivity = lazy(() => import("../pages/budgeting/activity/create"));
export const ViewBudgetActivity = lazy(() => import("../pages/budgeting/activity/view"));
export const EditBudgetActivityDetails = lazy(() => import("../pages/budgeting/activity/edit"));
